import React from "react";
import { Link as RouterLink } from "react-router-dom";
import clsx from "clsx";

interface AppLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  to: string;
  underline?: "none" | "hover" | "always";
}

const AppLink: React.FC<AppLinkProps> = ({
  children,
  to,
  underline = "hover",
  className = "",
  ...props
}) => {
  // Tailwind classes for underline behavior
  const underlineClasses = clsx({
    "no-underline": underline === "none",
    "no-underline hover:underline": underline === "hover",
    "underline": underline === "always",
  });

  // Combine classes
  const combinedClasses = clsx("flex text-primary items-center", underlineClasses, className);

  return (
    <RouterLink to={to} className={combinedClasses} {...props}>
      {children}
    </RouterLink>
  );
};

export default AppLink;